<template>
  <div>
    <div class="tab-pane-body-basic">
      <el-form ref="basicInfoForm" :model="goodsInfo" :rules="basicInfoRules" label-position="right" label-width="112px">
        <el-form-item label="商品名称" prop="goods_name">
          <el-input v-model="goodsInfo.goods_name"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="category_id">
          <el-cascader
            placeholder="选择分类"
            :props="cascaderProps"
            :options="categoryList"
            v-model="selectedList"
            @change="cascaderChange"
            show-all-levels
            clearable
            filterable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="商品图片" prop="image">
          <ApeUploader ref="apeapeuploader" :limit="8" uploadTip="尺寸750x750像素以上,最多上传8张，大小2M以下（可拖拽图片调整显示顺序）" @handleUploadSuccess="handleUploadSuccess" @handleUploadRemove="handleUploadRemove" :upload-file-list="uploadFileList" multiple></ApeUploader>
        </el-form-item>
        <el-form-item label="分享描述" prop="share_desc">
          <el-input type="textarea" v-model="goodsInfo.share_desc"></el-input>
        </el-form-item>
        <el-form-item label="商品卖点" prop="selling_point">
          <el-input type="textarea" v-model="goodsInfo.selling_point"></el-input>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeUploader from '@/components/ApeUploader'
import Sortable from 'sortablejs'

export default {
  components: {
    ApeUploader
  },
  props: {
    // 商品信息
    goodsInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  // 定义属性
  data() {
    return {
      // 商品基本信息规则
      basicInfoRules: {
        goods_name: [
          {required: true, message: '输入商品名称', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '请上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 分类联动
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      // 标签列表
      labelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已上传文件列表
      uploadFileList:[]
    }
  },
  // 方法集合
  methods: {
    async initGoodsCategory() {
      // 获取商品分类列表
      let data = await this.$api.getGoodsCategoryList()
      this.categoryList = data.category
      this.labelList = data.label
    },
    // 初始化基础信息
    initBasicInfo() {
      if (typeof(this.goodsInfo.goods_name) == 'undefined') {
        return false
      }
      this.selectedList = this.goodsInfo.category_ids
      this.uploadFileList = []
      for(let j = 0,tmp = this.goodsInfo.images_info,len = tmp.length; j < len; j++) {
        this.uploadFileList.push({id:tmp[j]['id'],name:tmp[j]['id'],url:tmp[j]['full_path'],full_path:tmp[j]['full_path']})
      }      
    },
    // 级联菜单组件change事件
    cascaderChange(v) {
      if (typeof(v)!='undefined' && v.length) {
        this.goodsInfo.category_id = v[(v.length-1)]
        this.goodsInfo.category_ids = v
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.goodsInfo.images = this.$utils.arrayColumn(fileList)
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].id
      }
      this.goodsInfo.images_info = fileList
      this.uploadFileList = fileList
      console.log(this.goodsInfo.images);
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.goodsInfo.images = this.$utils.arrayColumn(fileList)
      this.goodsInfo.images_info = fileList
      this.uploadFileList = fileList
    },
    // 基本信息表单验证
    formValidate() {
      this.$refs['basicInfoForm'].validate((valid) => {
        if (valid) {
          this.$emit('formSubmit',this.goodsInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },  
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && this.goodsInfo.images.length == 0) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 拖拽排序
    dragSort() {
      const el = document.querySelectorAll('.ape-uploader-image > ul')[0]
      this.sortable = Sortable.create(el,{
        handle: ".el-upload-list__item-actions", 
        onEnd: evt => {
          let tmp = evt.from.querySelectorAll('.el-upload-list__item-name')
          let tmp1 = evt.from.querySelectorAll('img')
          let ids = []
          let fileList = []
          for (let i=0,len=tmp.length; i < len; i++) {
            ids.push(tmp[i].text.replace(/(^\s*)|(\s*$)/g,""))
            fileList.push({id:tmp[i].text.replace(/(^\s*)|(\s*$)/g,""),name:tmp[i].text.replace(/(^\s*)|(\s*$)/g,""),url:tmp1[i].src,full_path:tmp1[i].src})
          }
          this.goodsInfo.images = ids
          this.goodsInfo.images_info = fileList
        },
      })
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initGoodsCategory()
    this.initBasicInfo()
    this.$nextTick(() => {
      this.dragSort()
    })
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-basic
    padding 16px
    width 60%
    margin-bottom 48px
    .el-select,.el-cascader
      width 100%
</style>